import { getRequestGateway } from '@/services/api.service'
import * as Sentry from '@sentry/browser'

let aborter = null
export async function getAllBuildingsGeoJSONv1(cancelPendingRequest, timeout) {
  try {
    const buildings = {
      type: 'geojson',
      data: {
        id: 'all-buildings',
        type: 'FeatureCollection',
        features: []
      }
    }
    if (cancelPendingRequest && aborter) aborter.abort()
    const res = await Promise.all([
      getRequestGateway('core/v1/constructions', timeout),
      getRequestGateway('core/v1/constructions/geojson', timeout)
    ])
    const response = res[0]
    const responseGeojson = res[1]
    const features = response.data
    const featuresGeojson = responseGeojson.data
    featuresGeojson.forEach((building) => {
      const feature = features.find((feature) => feature.id === building.id)
      if (feature) building.properties = feature // Replacing properties in geojson response with content from the constructions endpoint
    })
    // Adding building heights to constructions without height property (in this case because of unknown number of floors)
    featuresGeojson.forEach((building) => {
      if (!building.properties.height) {
        building.properties.height = 11
      }
      if (!building.properties.realEstateId) {
        building.properties.realEstateId = 'undefined'
      }
      if (!building.properties.complexId) {
        building.properties.complexId = 'undefined'
      }
      // Todo: Check with backend when the three measurements below can use measurements[0] only
      if (!building.properties.bta) {
        building.properties.bta =
          building.properties.measurements.length && building.properties.measurements[0].BTA
            ? building.properties.measurements[0].BTA
            : null
      }
      if (!building.properties.bra) {
        building.properties.bra =
          building.properties.measurements.length && building.properties.measurements[0].BRA
            ? building.properties.measurements[0].BRA
            : null
      }
      if (!building.properties.loa) {
        building.properties.loa =
          building.properties.measurements.length && building.properties.measurements[0].LOA
            ? building.properties.measurements[0].LOA
            : null
      }
      building.properties.areaEfficiency =
        building.properties.bta && building.properties.loa
          ? (building.properties.loa / building.properties.bta) * 100
          : null
    })
    buildings.data.features = featuresGeojson
    return buildings
  } catch (e) {
    console.error(e)
    Sentry.captureException(e)
    throw new Error('Could not fetch buildings')
  }
}

export async function getBuildingv1(id) {
  const response = await getRequestGateway(`core/v1/constructions/${id}`)
  return response
}

export async function getAggregatedMeasurements(id) {
  const response = await getRequestGateway(`core/v1/measurements?areaId=${id}`)
  return response
}
